import { render, staticRenderFns } from "./visitorDetail.vue?vue&type=template&id=65737358&scoped=true&"
import script from "./visitorDetail.vue?vue&type=script&lang=js&"
export * from "./visitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./visitorDetail.vue?vue&type=style&index=0&id=65737358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65737358",
  null
  
)

export default component.exports